import React, { useState } from "react";
import TEAMS from "../data/teams";

function Teams() {
  const [selected, setSelected] = useState(null);

  if (selected !== null) {
    const t = TEAMS[selected];
    return (
      <div style={{ padding: "16px 14px" }}>
        <button
          onClick={() => setSelected(null)}
          style={{ background: "transparent", border: "none", color: "#7d8590", fontSize: 14, cursor: "pointer", padding: 0, marginBottom: 18, display: "flex", alignItems: "center", gap: 6 }}
        >
          <span style={{ fontSize: 18 }}>‹</span> All Teams
        </button>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
          <div style={{ width: 6, height: 50, borderRadius: 3, background: t.color }} />
          <div>
            <h2 style={{ color: "#e6edf3", fontSize: 22, fontWeight: 700, margin: 0 }}>{t.name}</h2>
            <p style={{ color: "#7d8590", fontSize: 13, margin: "2px 0 0" }}>{t.players.length} players</p>
          </div>
        </div>
        <p style={{ color: "#7d8590", fontSize: 11, fontWeight: 700, letterSpacing: "1px", margin: "0 0 10px 2px" }}>ROSTER</p>
        {t.players.map(p => (
          <div key={p} style={{ background: "#161b22", border: "1px solid #30363d", borderRadius: 10, padding: "14px 16px", marginBottom: 10, display: "flex", alignItems: "center", gap: 14 }}>
            <div style={{ width: 40, height: 40, borderRadius: "50%", background: t.color + "22", border: `2px solid ${t.color}66`, display: "flex", alignItems: "center", justifyContent: "center", color: t.color, fontWeight: 700, fontSize: 15 }}>
              {p[0].toUpperCase()}
            </div>
            <p style={{ color: "#e6edf3", fontSize: 15, fontWeight: 600, margin: 0 }}>{p}</p>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div style={{ padding: "20px 14px" }}>
      <p style={{ color: "#7d8590", fontSize: 11, fontWeight: 700, letterSpacing: "1px", margin: "0 0 12px 2px" }}>ALL TEAMS</p>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {TEAMS.map((t, i) => (
          <button key={t.id} onClick={() => setSelected(i)}
            style={{ background: "#161b22", border: "1px solid #30363d", borderRadius: 12, padding: "14px 16px", display: "flex", alignItems: "center", gap: 14, cursor: "pointer", textAlign: "left", width: "100%" }}>
            <div style={{ width: 5, height: 46, borderRadius: 3, background: t.color, flexShrink: 0 }} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ color: "#e6edf3", fontSize: 15, fontWeight: 600, margin: 0 }}>{t.name}</p>
              <p style={{ color: "#7d8590", fontSize: 12, margin: "3px 0 0", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {t.players.join("  ·  ")}
              </p>
            </div>
            <span style={{ color: "#7d8590", fontSize: 18 }}>›</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default Teams;